module.exports = __webpack_public_path__ + "img/688.6727dd12.jpg";